/**
 * Transforms a flattened array back into nested array based on the structure of the nested `source`.
 * It is assumed that `source` and `flat` have the same number of elements - differing only in structure.
 *
 * Practically, this is useful for react query `useQueries` calls.
 *
 * @example
 *
 * unflatten([[1,2], [3,4]], ["a", "b", "c", "d"])
 * // => [["a", "b"], ["c", "d"]]
 */
export const unflatten = <TSource, TResult>(
  source: TSource[][],
  flat: TResult[],
  result: TResult[][] = [],
): TResult[][] => {
  if (source?.length === 0) {
    return result;
  }

  const [head, ...tail] = source;
  return unflatten(tail, flat.slice(head.length), [
    ...result,
    flat.slice(0, head.length),
  ]);
};
